'use strict';

const _ = require('underscore');
const HolyMenu = require('common/ui/view/svg/menu/holy');
const MenuIcon = require('common/ui/view/svg/menu/icon');
const ShapeFactory = require('common/ui/view/svg/shape/factory');
const SVGUtil = require('common/ui/view/svg/util');
const Diagrams = require('system/domain/value/diagrams');
const RecordTypeStore = require('system/domain/repository/record-type');

module.exports = HolyMenu.extend({
    initialize: function(params) {
        this.constructor.__super__.initialize.call(this, params);

        this.model = params.model;
        this._diagram = params.diagram;

        if(this.model) {
            this.listenTo(this.model, 'move', function(){
                const pos = {
                    x: this.model.meta.x,
                    y: this.model.meta.y,
                    scale: 1 / this.scale * this.scaleFactor
                };
                this.svg
                    .attr('transform', SVGUtil.transform(pos))
            });
        }

        const menus = [];
        _.each(Diagrams.getNodes(this._diagram.get('type')),
            function(type) {
                const typeModel = RecordTypeStore.getRecordTypes()
                    .get(type);
                const shape = typeModel.get('shape');
                const menu = {
                    name: type,
                    icon: MenuIcon.shapeIcon(new (ShapeFactory.find(shape.kind))(shape.attr)),
                    click: this.selectType(type),
                    text: typeModel.get('name')
                };

                // // ValueType はまだリリースしない
                // if(Balus.isProduction(Balus.Context.toJSON())) {
                //     if(type == 'ValueType') {
                //         return;
                //     }
                // }

                menus.push(menu);
            }, this);

        this.menus = menus;
    },

    selectType: function(type) {
        return _.bind(function() {
            this.hide();
            this.trigger('select:type', type, this);
        }, this);
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/menu/node-type.js